<template>
  <div class="col-md-6 col-sm-12">
    <div class="card extra-card shadow-sm" :class="{active: added}">
      <div class="custom-row">
        <div class="custom-col custom-checkbox-container">
          <label class="extra-checkbox" @click="toggleCheck">
            <span v-if="isChecked || currentValue > 0" class="extra-checkmark checked"><i
                class="fas fa-check"></i></span>
            <span v-else class="extra-checkmark"></span>
          </label>
        </div>
        <div class="card-info custom-col-grow">
          <h4 class="extra-title">{{extra.name}}</h4>
          <p class="extra-description">{{extra.description}}</p>
        </div>
        <div class="custom-col custom-col-right">
          <div class="">
            <b-col class="extra-counter-control-inline mr-0">
              <b-btn variant="btn-sm btn-circle" :class="{active: added}" @click="decrement" v-if="editMode"><i
                  class="far fa-minus"></i></b-btn>
              <div>
                <input type="text" class="extra-input" :class="{active: added}" :value="quantity"
                  readonly>
              </div>
              <b-btn :class="{active: added}" variant="btn-sm btn-circle" @click="increment" v-if="editMode"><i
                  class="far fa-plus"></i></b-btn>
            </b-col>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    extra: {
      type: Object,
      required: true
    },
    editMode: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      isChecked: this.extra.quantity > 0,
      currentValue: this.extra.quantity || 0
    };
  },
  computed: {
    added() {
      return this.extra.quantity > 0
    },
    quantity() {
      return this.extra.quantity
    },
  },
  methods: {
    toggleCheck() {
      this.isChecked = !this.isChecked;
      if (this.isChecked && this.currentValue === 0) {
        this.currentValue = 1;
      } else if (!this.isChecked) {
        this.currentValue = 0;
      }
      this.emitUpdate();
    },
    increment() {
      this.currentValue += 1;
      this.isChecked = true;
      this.emitUpdate();
    },
    decrement() {
      if (this.currentValue > 0) {
        this.currentValue -= 1;
      }
      if (this.currentValue === 0) {
        this.isChecked = false;
      }
      this.emitUpdate();
    },
    emitUpdate() {
      this.$emit('update-quantity', { extraId: this.extra.extra_id, quantity: this.currentValue });
    }
  }
}
</script>

<style scoped>

</style>